import Vue from 'vue';
require('es6-promise').polyfill();
import './assets/css/app.less';
import { createApp } from './app';
// eslint-disable-next-line
import VConsole from 'vconsole/dist/vconsole.min.js';
import { initOrUpdateApmInstanceConfig } from './util/apm';
import { initUniversalBridge } from './util/platform/universal-bridge';
import { initSensor } from './util/sensor';

// 神策初始化
initSensor();

// const isProd = process.env.NODE_ENV === 'production';
if (
    window.env === 'local' ||
    window.env === 'dev' ||
    window.env === 'test' ||
    window.env === 'stg'
) {
    new VConsole();
}

if (window.env === 'prod') {
    initOrUpdateApmInstanceConfig({
        plugins: {
            vueErrorHandler: { app: Vue }
        }
    });
}

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
// actually mount to DOM
initUniversalBridge().then(() => {
  const { app, store } = createApp();
  store.replaceState(window.__INITIAL_STATE__);
  app.$mount('#app');
});



// WEBPACK FOOTER //
// ./src/client-entry.js